import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useGetPostRepliesQuery } from "../../../../redux/apiSlice";
import { SocialPost } from "./SocialPost";
import { BackIcon } from "../../../util/Icons";

export const SocialPostReplies = ({ post, selectPost }) => {
  const { isFetching, data } = useGetPostRepliesQuery({
    profileId: post?.user?.profileId,
    postId: post?.postId,
  });

  return (
    <div className="col d-flex flex-column h-100 w-100 pt-8">
      <Row>
        <Col sm={3}>
          <Button
            size="sm"
            variant="dark"
            className="px-0 w-100 mb-3"
            onClick={() => selectPost(null)}
          >
            <div className="d-flex">
              <BackIcon size={"14px"} className="ml-2" />
              <div className="text-center flex-fill font-weight-bolder px-2">
                Back To Posts
              </div>
            </div>
          </Button>
        </Col>
      </Row>
      <div>
        <SocialPost post={post} isReply={true} />
      </div>
      <div className="font-size-lg font-weight-bolder">Replies</div>
      <div className="flex-grow-1 mb-8 mt-3">
        {!isFetching &&
          data &&
          data.data.map((reply) => {
            return (
              <SocialPost post={reply} key={reply?.postId} isReply={true} />
            );
          })}
      </div>
      <div className="d-flex justify-content-between">
        <Button variant="secondary font-weight-bolder">Prev</Button>
        <Button variant="secondary font-weight-bolder">Next</Button>
      </div>
    </div>
  );
};
